import { render, staticRenderFns } from "./EmployeeDetailsCardEmploymentsHistory.vue?vue&type=template&id=25633e68&"
import script from "./EmployeeDetailsCardEmploymentsHistory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmployeeDetailsCardEmploymentsHistory.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports